import {call, put, takeLatest} from 'redux-saga/effects';
import userActions from '../actions/user.actions';
import UserApi from '../api/UserApi';
import errorActions from '../actions/error.actions';

export function* checkSignupRequirementsMet() {
    try {
        const result = yield call(UserApi.checkSignupRequirementsMet, {});
        yield put(userActions.checkSignupRequirementsMetSuccess(result));
    } catch (e) {
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(userActions.checkSignupRequirementsMetFailed(e));
    }
}

function* userSaga() {
    yield takeLatest(userActions.TYPES.CHECK_SIGNUP_REQUIREMENTS_MET, checkSignupRequirementsMet);
}

export default userSaga;
